const namespace = "group_code";

export const group_code = `${namespace}_list`;
export const group_code_category = `${namespace}_category_list`;
export const group_code_category_select = `${namespace}_category_select`;
export const group_code_select = `${namespace}_select`;
export const group_codeSelectData = `${namespace}_select_data`;
